import React from 'react';
import { NoMatchText, MacroButton } from '../../../../DecisionTree.styles';
import { useDispatch } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT_EDGES } from 'constants/decisionTree';
const { NO_CUSTOMER_OR_ACCOUNT_FOUND } = SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT_EDGES;

const NoSearchResults = () => {
  const dispatch = useDispatch();

  return (
    <>
      <NoMatchText marginTop={'10px'}>Next steps you can take:</NoMatchText>
      <NoMatchText marginTop={'10px'}>1. You can try asking the customer which email was used to sign up.</NoMatchText>
      <NoMatchText marginTop={'7px'}>
        2. Once you have received a response from the customer, use the updated <br />
        customer information to search again.
      </NoMatchText>
      <MacroButton active={true} onClick={() => dispatch(addEdgeToDecisionTreePath(NO_CUSTOMER_OR_ACCOUNT_FOUND))}>
        GET MACRO
      </MacroButton>
    </>
  );
};

export default NoSearchResults;
